import { render, staticRenderFns } from "./CommunityPage.vue?vue&type=template&id=b629eac0&scoped=true&"
import script from "./CommunityPage.vue?vue&type=script&lang=js&"
export * from "./CommunityPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b629eac0",
  null
  
)

export default component.exports